export default __webpack_public_path__ + "static/media/day_empty.11a3a0df.svg";